import { useEffectOnce } from "./useEffectOnce";

const useWillUnmount = (callback: () => void): void => {
  useEffectOnce(() => {
    return () => {
      callback();
    };
  });
};

export { useWillUnmount };
